import React from "react";
import cns from "classnames";
import { withStyles } from "@material-ui/core";
import Select, { SelectProps } from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

type OwnProps = SelectProps & {
  autoOpen?: boolean;
  options: Array<{ label: string; value: string }>;
};

type State = {
  isOpen: boolean;
};

type Props = OwnProps & {
  classes: any;
};

const styles = (theme) => ({
  root: {
    fontSize: "0.8rem",
    fontWeight: 600
  },

  error: {
    border: "1px solid red",
    borderRadius: theme.radius
  },

  selectMenu: {
    padding: 0
  },

  select: {
    paddingRight: 20
  }
});

export class InlineSelect extends React.Component<Props, State> {
  static defaultProps = {
    options: []
  };

  constructor(props) {
    super(props);

    this.state = {
      isOpen: this.props.autoOpen ? true : false
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.autoOpen !== this.props.autoOpen) {
      this.setState({ isOpen: this.props.autoOpen });
    }
  }

  render() {
    const { autoOpen, options, value = "", classes, ...rest } = this.props;

    const rootClassName = cns({
      [classes.error]: this.props.error
    });

    const { error, ...restClasses } = classes;

    return (
      <Select
        {...rest}
        data-test="InlineSelect"
        data-test-error={this.props.error}
        data-test-value={value}
        open={this.state.isOpen}
        classes={restClasses}
        className={rootClassName}
        onOpen={() => this.setState({ isOpen: true })}
        onClose={() => this.setState({ isOpen: false })}
        value={value}
      >
        {options.map((option) => (
          <MenuItem
            data-test="MenuItem"
            data-test-id={option.value}
            key={option.value}
            value={option.value}
          >
            {option.label}
          </MenuItem>
        ))}
      </Select>
    );
  }
}

export default withStyles(styles as any)(InlineSelect) as React.ComponentClass<OwnProps>;
